import { Component, Injectable, OnInit, OnDestroy } from '@angular/core';
import { AuthenticationService, TestData, TokenPayload } from '../services/authentication.service';
import { Router } from '@angular/router';
import {MediaMatcher} from '@angular/cdk/layout';
import {ChangeDetectorRef} from '@angular/core';
import { NgForm } from '@angular/forms';


@Component({
  templateUrl: './super_admin.component.html',
  styleUrls: ['./super_admin.component.scss']
})
@Injectable()
export class SuperAdminComponent implements OnInit, OnDestroy {

  result: string[];
  // admin_result: string[];
  // test_Scheduler_result: string[];
  userAdmin: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  details: boolean;
  questionset: boolean;
  scheduletest: boolean;
  overall: boolean;
  mobileQuery: MediaQueryList;
  evaluate: boolean;
  private _mobileQueryListener: () => void;

  links = ['Super Admin', 'Admin', 'Test Scheduler'];
  user;
  fname;
  lname;
  time = new Date()
  userEvaluator: boolean;
  hostNameFromWeb: string;
  constructor(private auth: AuthenticationService, private router: Router, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher ) {
    this.getAccess();
    this.simpletest();
    // this.admin();
    // this.testScheduler();
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }
  columns: string[];
  // tslint:disable-next-line: member-ordering

  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };


  ngOnInit() {
    this.columns = this.auth.getSAColumns();
    this.hostNameFromWeb = window.location.host
      console.log("Printing the hostname ",this.hostNameFromWeb);
   }

  // getAccess(){
  //   this.user = sessionStorage.getItem('user');
  //   this.fname = sessionStorage.getItem('fname');

  //   this.lname = sessionStorage.getItem('lname');


  //   if (this.user === '1') {

  //     this.userAdmin = true;
  //     this.userSuperAdmin = true;
  //     this.userTestScheduler =false;
  //   }
  // }

  getAccess(){
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');


    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;
    } else if (this.user === '3') {
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }

  simpletest() {
      this.auth.superadmin(this.test).subscribe(
      (data) => {

       this.details = true;
       this.user = sessionStorage.getItem('user');
       this.fname = sessionStorage.getItem('fname');

       this.lname = sessionStorage.getItem('lname');


       this.result = data.results;
       console.log("this.result",this.result)
       return this.result;

      },
      err => {
        console.error(err);
      }
    );
  }

  edit(user) {


    this.router.navigate(['/edit', user.id]);

    ///var currentTimeInMilliseconds=Date.now(); 
    //console.log(currentTimeInMilliseconds);
    //this.time.getTime();
    console.log(this.time)
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

}
